import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import { t } from "../../i18n/i18next";
import type { AccountCreationSideEffects } from "../../redux/types/Authentication";
import VSpinner from "../ui/spinners/VSpinner";
import { getAuthenticationRegistrationUrl } from "../utilities/AuthenticationUtils";
import { useStandaloneAuthenticationSession } from "../utilities/useStandaloneAuthenticationSession";
import RegistrationForm from "./RegistrationForm";
import RegistrationSuccess from "./RegistrationSuccess";

const ViridisRegister = () => {
    const authentication = useStandaloneAuthenticationSession();
    const redirectStarted = useRef(false);
    const [registered, setRegistered] = useState(false);
    const [email, setEmail] = useState("");
    const [creationResult, setCreationResult] =
        useState<AccountCreationSideEffects>({});

    useEffect(() => {
        if (
            authentication.status === "ready" &&
            authentication.session.authenticationMode === "OIDC" &&
            !redirectStarted.current
        ) {
            redirectStarted.current = true;
            window.location.assign(getAuthenticationRegistrationUrl("/"));
        }
    }, [authentication]);

    if (
        authentication.status === "checking" ||
        (authentication.status === "ready" &&
            authentication.session.authenticationMode === "OIDC")
    ) {
        return (
            <Container className="text-center">
                <VSpinner />
                <p>{t("Redirecting to account creation")}</p>
            </Container>
        );
    }

    if (authentication.status === "error") {
        return (
            <Container className="text-center">
                <Alert variant="warning">{authentication.error}</Alert>
                <Button onClick={authentication.retry}>{t("Retry")}</Button>
            </Container>
        );
    }

    const success = (
        registeredEmail: string,
        result: AccountCreationSideEffects
    ) => {
        setEmail(registeredEmail);
        setCreationResult(result);
        setRegistered(true);
    };

    const body = registered ? (
        <RegistrationSuccess email={email} result={creationResult} />
    ) : (
        <RegistrationForm callback={success} />
    );

    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <h2 className="text-center">
                        {t("Create a Pocketbook account")}
                    </h2>
                </Col>
                <Col xs={12} md={{ span: 8, offset: 2 }}>
                    {body}
                </Col>
            </Row>
        </Container>
    );
};

export default ViridisRegister;
